import { render, staticRenderFns } from "./c-diff-preview-popup.vue?vue&type=template&id=b080614a"
import script from "./c-diff-preview-popup.vue?vue&type=script&lang=js"
export * from "./c-diff-preview-popup.vue?vue&type=script&lang=js"
import style0 from "./c-diff-preview-popup.vue?vue&type=style&index=0&id=b080614a&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b080614a')) {
      api.createRecord('b080614a', component.options)
    } else {
      api.reload('b080614a', component.options)
    }
    module.hot.accept("./c-diff-preview-popup.vue?vue&type=template&id=b080614a", function () {
      api.rerender('b080614a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/list/popups/c-diff-preview-popup.vue"
export default component.exports